import {
  Box,
  Button,
  Grid,
  Typography,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import { HeaderFiltro } from "../header-filtro";
import { useOcupacaoService } from "../../../../../../../use-cases/geo-veles/ocupacao";
import { DialogFiltroCBO } from "./DialogFiltroCBO";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
// Icons
import AddIcon from "@mui/icons-material/Add";
import { useListaCboService } from "../../../../../../../use-cases/geo-veles/lista-cbo";
import { CreateListaCboForm, PreviewListaCBO } from "./forms";
import { EditListaCbosForm } from "./forms/editListaCboForm";
import { ListaCboImportFile } from "./forms/listaCboImportFile";
import { IListaCbo } from "../../../../../../../application/models/geo-veles/IListaCbo";
import { DialogListaCbo } from "./DialogFiltroListaCBOs";
import { CBOFilterPreview } from "./cbo-filter-preview";
import { useEffect } from "react";
import { useAppDispatch } from "../../../../../../hooks/store-hooks";
import { selectListaCbo, clearSelectedListasCbo,  } from "../../../../../../../application/states/geo-veles/lista-cbo";
import { ListaCBOFilterPreview } from "./cbo-filter-preview/ListaCBOFilterPreviewExtern";

export const FiltroCBO = () => {
  const dispatch = useAppDispatch();
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos);

  const { listasCbo: todasAsListasCbo, selectedListasCbo } = useAppSelector(
    (state) => state.listaCbo
  );

  const selectedIds = new Set(selectedListasCbo.map(l => l.IdVelesGeoListaCBO));
  const listasDisponiveis = todasAsListasCbo.filter(
    (lista: IListaCbo) => !selectedIds.has(lista.IdVelesGeoListaCBO)
  );

  const { setOpenOcupacaoDialog, setCategoria } = useOcupacaoService();
  const { setOpenListaCboDialog, setupListasCbo } = useListaCboService();

  useEffect(() => {
    setupListasCbo();
  }, [setupListasCbo]);

  useEffect(() => {
    if (!filtrosSelecionados?.listasCbo || filtrosSelecionados.listasCbo.length === 0) {
      dispatch(clearSelectedListasCbo());
    }
  }, [filtrosSelecionados?.listasCbo, dispatch]);

  useEffect(() => {
    if (filtrosSelecionados?.listasCbo &&
      filtrosSelecionados.listasCbo.length > 0 &&
      listasDisponiveis.length > 0 &&
      filtrosSelecionados.listasCbo.length !== selectedListasCbo.length) {


      const timeoutId = setTimeout(() => {
        const listasParaRestaurar = (filtrosSelecionados?.listasCbo || [])
          .map((id: number) => listasDisponiveis.find((lista: IListaCbo) => lista.IdVelesGeoListaCBO === id))
          .filter((lista: IListaCbo | undefined): lista is IListaCbo => lista != null);

        if (listasParaRestaurar.length > 0 && selectedListasCbo.length === 0) {
          listasParaRestaurar.forEach((lista: IListaCbo) => {
            dispatch(selectListaCbo({ lista }));
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [filtrosSelecionados?.listasCbo, listasDisponiveis, dispatch, selectedListasCbo.length]);

  const listasSelecionadasCompletas = selectedListasCbo.length > 0
    ? selectedListasCbo
    : (filtrosSelecionados?.listasCbo || [])
      .map((id) => {
        const lista = todasAsListasCbo.find(
          (lista) => String(lista.IdVelesGeoListaCBO) === String(id)
        );
        return lista;
      })
      .filter((lista): lista is IListaCbo => lista != null);



  const hasCBOs = (filtrosSelecionados?.cbo?.length ?? 0) > 0;
  const hasListas = listasSelecionadasCompletas.length > 0;


  return (
    <>
      <HeaderFiltro
        titulo="CBO / Ocupação"
        descricao={
          <>
            <Typography>
              Este filtro permite buscar pessoas através da ocupação que exercem.
            </Typography>
            <Typography style={{ marginBottom: "10px" }}>
              Você pode abrir a lista de ocupações disponíveis e selecionar quantas desejar.
            </Typography>
            <Typography>
              Caso nenhuma opção seja selecionada, não levaremos o CBO em consideração durante a busca.
            </Typography>
          </>
        }
      />

      <Box my={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => setOpenListaCboDialog(true)}
              endIcon={<AddIcon />}
            >
              <Typography variant="body1" fontWeight="bold">
                Adicionar Lista de Ocupações
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => {
                setOpenOcupacaoDialog(true);
                setCategoria("cbosearch");
              }}
              endIcon={<AddIcon />}
            >
              <Typography variant="body1" fontWeight="bold">
                Adicionar ocupações
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Exibe o Accordion apenas se houver algo selecionado */}
      {(hasCBOs || hasListas) && (
        <Accordion defaultExpanded sx={{ my: 2 }}>
          <AccordionDetails>
            {/* Ocupações individuais */}
            {hasCBOs && <CBOFilterPreview />}

            {/* Listas de ocupações */}
            {hasListas && <ListaCBOFilterPreview />}
          </AccordionDetails>
        </Accordion>
      )}

      {/* Dialogs e forms */}
      <DialogFiltroCBO />
      <DialogListaCbo />
      <CreateListaCboForm />
      <EditListaCbosForm openForm={true} />
      <ListaCboImportFile />
      <PreviewListaCBO openPreviewListaCBO={true} />
    </>
  );
}